import classNames from 'classnames'
import PropTypes from 'prop-types'
import React from 'react'
import { storeNameColumn } from 'TableCommon/defaultColumns'

import Box from '@mui/material/Box'

const TitleIcons = storeNameColumn.RowRenderer

const TableReplenishmentsRow = ({ data, index, style }) => {
  const { showModal, maxReplenishments, stores } = data
  const store = stores[index]
  const modalHandler = () => showModal(store)
  const barWidth = Math.round((100 * store.replenishmentOnHandShoesCurrent) / maxReplenishments)

  return (
    <Box
      style={style}
      onClick={modalHandler}
      className={classNames('row cursor-pointer', { 'is-temporary-closed': store.temporaryClosed })}
    >
      <div className="row-wrapper flex-row">
        <div className="cell-bar" style={{ width: `${barWidth}%` }} />

        <div className="cell-title flex-row">
          <TitleIcons {...data} store={store} />
        </div>

        <div className="cell-category tablet-portrait-up-only">
          <span className={classNames('category', `is-${store.cluster === '-' ? 'none' : store.cluster.toLocaleLowerCase()}`)}>
            {store.cluster}
          </span>
        </div>

        <div className="cell cell-replenishment-shoes">
          <span>
            <span className="cell-replenishment-other_current">{Math.round(store.replenishmentOnHandShoesCurrent * 100)}%</span>
            {' / '}
            {Math.round(store.replenishmentTargetShoesCurrent * 100)}%
          </span>
        </div>

        <div className="cell cell-replenishment-other">
          <span>
            <span className="cell-replenishment-other_current">{Math.round(store.replenishmentOnHandOthersCurrent * 100)}%</span>
            {' / '}
            {Math.round(store.replenishmentTargetOthersCurrent * 100)}%
          </span>
        </div>
      </div>
    </Box>
  )
}

TableReplenishmentsRow.propTypes = {
  data: PropTypes.shape({
    maxReplenishments: PropTypes.number,
    showModal: PropTypes.func,
    stores: PropTypes.arrayOf(PropTypes.object),
  }),
  index: PropTypes.number,
  style: PropTypes.object,
}

export default TableReplenishmentsRow
